export default __webpack_public_path__ + "static/media/img-gt-mode-gt-bg-be_dt.8109254e.jpg";